import { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import DownloadIcon from "@mui/icons-material/Download";

export default function HeaderSession(props) {
    const { title, maiusculo, actions, handleExportExcel, handleExportPDF } = props;
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const displayTitle = maiusculo ? title?.toUpperCase() : title;

    return (
        <div className="tw-my-6 ">
            <div className="tw-flex tw-items-center tw-py-3">

                {/* Botão Voltar */}
                <button
                    onClick={() => navigate(-1)}
                    title="Voltar"
                    className="tw-border-none tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-lg tw-mr-3 tw-flex-shrink-0 tw-transition-colors tw-duration-200 hover:tw-bg-gray-100 tw-cursor-pointer"
                >
                    <img width={20} src="/img/icones/setaback1.svg" alt="" />
                </button>

                {/* Título */}
                <h1
                    className="tw-text-xl tw-font-bold tw-text-gray-800 tw-flex-1 tw-leading-tight"
                    translate="no"
                >
                    {displayTitle}
                </h1>

                {/* Menu de exportação (opcional) */}
                {actions && (
                    <div className="tw-relative" ref={menuRef}>
                        <button
                            onClick={() => setMenuOpen(prev => !prev)}
                            title="Opções para baixar"
                            className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-border-gray-200 tw-text-sm tw-text-gray-600 tw-transition-all tw-duration-200 hover:tw-border-[#85287e]/40 hover:tw-text-[#85287e]"
                        >
                            <DownloadIcon sx={{ fontSize: 18 }} />
                            <span className="tw-font-medium">Exportar</span>
                        </button>

                        {menuOpen && (
                            <>
                                {/* overlay para fechar o menu */}
                                <div className="tw-fixed tw-inset-0 tw-z-10" onClick={() => setMenuOpen(false)} />
                                <div className="tw-absolute tw-right-0 tw-top-full tw-mt-1 tw-z-20 tw-bg-white tw-rounded-lg tw-border tw-border-gray-100 tw-shadow-lg tw-py-1 tw-min-w-[150px]">
                                    <button
                                        onClick={() => { handleExportExcel?.(); setMenuOpen(false); }}
                                        className="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-50 hover:tw-text-[#85287e] tw-transition-colors"
                                    >
                                        <DownloadIcon sx={{ fontSize: 16 }} />
                                        Baixar Excel
                                    </button>
                                    <button
                                        onClick={() => { handleExportPDF?.(); setMenuOpen(false); }}
                                        className="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-50 hover:tw-text-[#85287e] tw-transition-colors"
                                    >
                                        <DownloadIcon sx={{ fontSize: 16 }} />
                                        Baixar PDF
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>

            {/* Divisor */}
            <div className="tw-h-0.5 tw-bg-[#c43ab9]/60 tw-rounded-full" />
            <div className="tw-mb-4" />
        </div>
    );
}
